import React, { useCallback, useState } from "react";
import axios from "axios";

import InputSearchUser from "./InputSearchUser";

const STATE_DEFAULT = {
  users: [],
  aux: [],
  user: null,
};

function useUser() {
  const [state, setState] = useState(STATE_DEFAULT);

  const setUsers = useCallback(
    (_new) => {
      setState((old) => ({
        ...old,
        users: _new,
      }));
    },
    [setState]
  );

  const setUser = useCallback(
    (_new) => {
      setState((old) => ({
        ...old,
        user: _new,
      }));
    },
    [setState]
  );

  const getUsers = useCallback((is_mounted = true) => {
    axios.get("user/list-user-pending").then((res) =>
      is_mounted
        ? setState({
            users: res.data,
            aux: res.data,
            user: null,
          })
        : null
    );
  }, []);

  return {
    ...state,
    getUsers,
    setUsers,
    setUser,
    setState,
  }
}

export default useUser;
